import { getCartMachine } from '../../core/cart/index.js';
import { sendCartDrawerOpenRequestEvent } from '../../core/notifications/cart-drawer-open-request.js';
import { generateGiftSetId } from './generate-gift-set-id.js';
/*
 * Adds a single variant by id. `createRawItemPayload` is form-only, so the
 * payload is built directly, and the cart machine does not report to
 * analytics - every caller publishes `add_to_cart` itself.
 *
 * `_gift_set_id` (null by default on every cart item) flags the line so the
 * cart renders it with `cart-item-gift-set`, which lets the customer attach a
 * gift message. It is unique per add, so Shopify keeps every gift set on its
 * own line instead of merging them into one line with a higher quantity.
 *
 * The drawer request is sent before the await so it opens straight away and
 * fills in once the line is on the cart, matching `_js/product/details`.
 */ export const addVariantToCart = async (product, variant)=>{
    const payload = {
        id: variant.id,
        quantity: 1,
        properties: {
            _gift_set_id: generateGiftSetId()
        }
    };
    sendCartDrawerOpenRequestEvent();
    await new Promise(function(resolve, reject) {
        getCartMachine().addItems({
            resolve,
            reject,
            input: {
                items: [
                    payload
                ]
            }
        });
    });
    var _variant_sku;
    Shopify.analytics.publish('add_to_cart', {
        event: 'Add to Cart',
        productsToAdd: [
            {
                sku: (_variant_sku = variant.sku) !== null && _variant_sku !== void 0 ? _variant_sku : 'Unknown',
                productType: product.type,
                name: product.title,
                price: variant.price,
                quantity: 1,
                variantName: `${product.title} - ${variant.title}`
            }
        ],
        source: 'mini_cart'
    });
};
export const getVariantById = (product, variantId)=>product.variants.find((variant)=>variant.id === variantId) || null;
